// BG
export const locale = {
  LANGUAGE: "Език",
  BULGARIAN: "Български",
  ENGLISH: "Английски",
  HELLO: "Здравей",
  PLEASE_CHANGE_YOUR_PASSWORD: "Моля, променете паролата си",
  EXIT: "Изход",
  HOME: "Начало",
  PRODUCTS: "Продукти",
  EDIT_PRODUCT: "Редакция на продукт",
  RAW_PRODUCTS: "Суровини",
  EDIT_RAW_PRODUCT: "Редакция на суровина",
  MATERIALS: "Материали",
  EDIT_MATERIAL: "Редакция на материал",
  MATERIAL_REQUIREMENTS: "Материали - изисквания",
  EDIT_MATERIAL_REQUIREMENT: "Редакция на изискване за материал",
  VENDORS: "Производители",
  MANUFACTURE_TYPES: "Тип изделие",
  EDIT_VENDOR: "Редакция на доставчик",
  PRINTING_HOUSES: "Печатници",
  EDIT_PRINTING_HOUSE: "Редакция на печатница",
  CLIENTS: "Клиенти",
  EDIT_CLIENT: "Редакция на клиент",
  OPERATORS: "Оператори",
  EDIT_OPERATOR: "Редакция на оператор",
  OPERATOR_HOLIDAYS: "Почивни дни за оператор",
  WAREHOUSES: "Складове",
  EDIT_WAREHOUSE: "Редакция на склад",
  USERS: "Потребители",
  EDIT_USER: "Редакция на потребител",
  PROFILE: "Профил",
  MATERIAL_REQUEST: "Заявка за лекарствен продукт",
  EDIT_MATERIAL_REQUEST: "Редакция на заявка за лекарствен продукт",
  CERTIFICATE_OF_RELEASE_OF_PACKAGING_MATERIALS: "Сертификат за освобождаване на опаковъчни материали",
  EDIT_CERTIFICATE_OF_RELEASE_OF_PACKAGING_MATERIALS: "Редакция на сертификат за освобождаване на опаковъчни материали",
  DESTRUCTION_PROTOCOL_OF_SECONDARY_PACKAGING_MATERIALS: "Протокол за унищожаване на вторични опаковъчни материали",
  EDIT_DESTRUCTION_PROTOCOL_OF_SECONDARY_PACKAGING_MATERIALS: "Редакция на протокол за унищожаване на вторични опаковъчни материали",
  INVOICES: "Фактури",
  EDIT_INVOICE: "Редакция на фактура",
  STATISTICS: "Статистика",
  QUANTITY_IN_STOCK: "Стока в наличност",
  NORMS: "Норми",
  SETTINGS: "Настройки",
  WORK_BREAKS: "Почивки",
  EDIT_WORK_BREAK: "Редактиране на почивка",
  WORKING_TIME: "Работно време",
  SCRAP_REGISTER: "Регистър брак",
  SAMPLE_REGISTER: "Регистър мостри",
  CERTIFICATE_OF_RELEASE_FOR_SALE_OF_FINAL_PRODUCT: "Сертификат Освобождаване за продажба на краен продукт",
  EMAILS: "Имейли",
  EDIT_EMAIL: "Редакция на имейл",
  ROUTE_MAPS_FOR_LOADING: "Маршрутни карти за зареждане",
  LOGS: "Логове",
  ROUTE_MAP: "Маршрутна карта",
  NEW_ROUTE_MAPS: "Нови маршрутни карти",
  CURRENT_ROUTE_MAPS: "Текущи маршрутни карти",
  ROUTE_MAP_OPERATIONS: "Операции на маршрутна карта",
  EDIT_ROUTE_MAP: "Редакция на маршрутна карта",
  DONE_ROUTE_MAPS: "Завършени маршрутни карти",
  HALLS: "Зали",
  EDIT_HALL: "Редакция на зала",
  LOGIN: "Вход",
  TWO_FACTOR_AUTHENTICATION: "Двуфакторно удостоверяване",
  REGISTRATION: "Регистрация",
  FORGOTTEN_PASSWORD: "Забравена парола",
  RESET_PASSWORD: "Нулиране на парола",
  MODULES: "Модули",
  ROUTE_MAPS: "Маршрутни карти",
  NOMENCLATURE: "Номенклатура",
  DOCUMENTS: "Документи",
  CREATE: "Създай",
  NEW_ROUTE_MAPS_MENU: "Нови",
  CURRENT: "Текущи",
  DONE: "Завършени",
  APPROVE_REANALYSIS: "Одобри преанализ",
  SOMETHING_WENT_WRONG: "Нещо се обърка",
  ARCHIVE: "Архивирай",
  REANALYSIS_REQUEST: "Заявка за преанализ",
  DECLINE_REANALYSIS: "Откажи преанализ",
  DELETE: "Изтрий",
  DELETE_CONFIRMATION: "Сигурни ли сте, че искате да изтриете този запис?",
  DELETE_CONFIRMATION_DESCRIPTION: "Това действие не може да бъде отменено!",
  DELETE_CONFIRMATION_DESCRIPTION_SAVE_CHANGES: "За да завършите това действие, трябва да запишете промените!!",
  OK_TEXT: "Потвърди",
  CANCEL_TEXT: "Откажи",
  EDIT: "Редакция",
  PREVIEW: "Преглед",
  PRINT_STICKERS: "Принтирай стикери",
  PRINTING_STICKERS: "Принтиране на стикери",
  PRINTER_WORKING_CHECK: "Моля убедете се, че принтера работи и е включен във Вашия компютър!",
  LOAD_PRINTER: "Моля заредете принтера",
  WITH_SHORT: "с",
  WITH_LONG: "със",
  STICKERS: "стикери",
  NO_PRINTER_CONNECTION: "Няма връзка с принтера",
  CERTIFICATE: "Сертификат",
  COUNT: "Брой",
  PRINT: "Принтирай",
  STICKER_STATUS_FREE: "ОСВОБОДЕНО",
  STICKER_STATUS_BLOCKED: "БЛОКИРАН",
  STICKER_STATUS_PROBATION: "ПРОБОВЗЕТО/КАРАНТИНА",
  STICKER_COLOR_GREEN: "ЗЕЛЕНИ",
  STICKER_COLOR_RED: "ЧЕРВЕНИ",
  STICKER_COLOR_YELLOW: "ЖЪЛТИ",
  PROCESS_REANALYSIS: "Извърши преанализ",
  SIGN: "Подпиши",
  LOG: "Лог",
  EMAIL_NOT_FOUND: "Имейлът не е намерен!",
  CERTIFICATE_CANNOT_BE_DELETED_BECAUSE_IT_IS_IN_PRODUCTION_OR_HAS_DESTROYED_BATCHES: "Сертификата не може да бъде изтрит, тъй като вече е в производство или има унищожени бройки от него!",
  MATERIAL_PROPERTY_CANNOT_BE_DELETED_BECAUSE_IT_IS_CONNECTED_TO_MATERIALS: "Изискването не може да бъде изтрито, защото има свързани материали!",
  ACCEPTANCE_ACT_CANNOT_BE_DELETED_BECAUSE_IT_IS_IN_PRODUCTION: "Приемно предавателния протокол не може да бъде изтрит, тъй като вече е в производство!",
  MATERIAL_CANNOT_BE_DELETED_BECAUSE_IT_HAS_CERTIFICATES: "Материалът не може да бъде изтрит, защото има свързани сертификати!",
  CLIENT: "Клиент",
  DATE: "Дата",
  BATCH: "Партида",
  QUANTITY: "Количество",
  RAW_PRODUCT: "Суровина",
  EXPIRATION_DATE: "Срок на годност",
  FROM_WAREHOUSE: "От склад",
  TO_WAREHOUSE: "Към склад",
  ADD_RECORD: "Добави запис",
  CREATED_AT: "Създаден на",
  UPDATED_AT: "Променен на",
  NAME: "Име",
  ACTIONS: "Действия",
  DOWNLOAD: "Изтегли",
  DOWNLOAD_DOCUMENT: "Изтегли документ",
  ADD: "Добави",
  ACCEPTANCE_ACT: "Приемно-предавателен протокол",
  ERROR: "Грешка",
  PAGE_NOT_FOUND: "Страницата не е намерена!",
  OPERATIONS: "Операции",
  DOWNLOAD_DOCUMENT_ACCEPTANCE_ACT: "Изтегли документ ППП",
  PURCHASER: "Възложител",
  BATCH_NUMBER_OF_PRODUCER: "Партидeн номер на производител",
  PRINTING_HOUSE: "Печатница",
  DELIVERY_DATE: "Дата на доставка",
  CONCLUSION_PROTOCOL: "Заключение (Протокол)",
  CONCLUSION_CERTIFICATE: "Заключение (Сертификат)",
  CONCLUSION_PROTOCOL_DESCRIPTION: "Опаковъчните материали отговарят на съпътстващата документация (ППП, експедиционно нареждане, заявка), извършено е пробовземане и предстои окачествяване на съответния ВОМ съгласно спецификация /МОЛЯ ПОПЪЛНЕТЕ/",
  MATERIAL: "Материал",
  MODIFY: "Промени",
  CERTIFICATE_OF_RELEASE_OF_PACKAGING_MATERIAL: "Сертификат за освобождаване на опаковъчен материал",
  CERTIFICATE_OF_RELEASE_OF_PACKAGING_MATERIALS: "Сертификат за освобождаване на опаковъчни материали",
  ARCHIVED: "Архивиран",
  DOWNLOAD_REGISTER_FOR_RECEIVING_AND_REGISTERING_INTERNAL_BATCH_NUMBER_OF_BOM: "Изтегли Регистър за получаване и регистриране на Вътрешен партиден номер на BOM",
  SEARCH_BY_YEAR: "Търси по година",
  SIGNED: "Подписан",
  QUARANTINE: "Карантина",
  YES: "Да",
  NO: "Не",
  GENERATE_CERTIFICATE: "Генерирай сертификат",
  RETURN_TO_QUARANTINE_STATUS: "Върни до статус карантина",
  DOWNLOAD_CERTIFICATE: "Изтегли сертификат",
  DOWNLOAD_PROTOCOL: "Изтегли протокол",
  CONNECTED_RM: "Свързани МК",
  GENERATING_OF_CERTIFICATE: "Генериране на сертификат",
  STATUS: "Статус",
  MEETS: "Отговаря",
  DOES_NOT_MEETS: "Не отговаря",
  GENERATE: "Генерирай",
  CONNECTED_ROUTE_MAPS: "Свързани маршрутни карти",
  MANAGER: "Мениджър",
  NO_RESULTS_FOUND: "Няма намерени резултати",
  CONCLUSION_CERTIFICATE_DESCRIPTION: "Опаковъчните материали отговарят на изискванията на утвърдената спецификация за окачествяване на опаковъчен материал на {type} - СП БФ КК № /МОЛЯ ПОПЪЛНЕТЕ/",
  REASONS: "Причини",
  CERTIFICATE_CANNOT_BE_GENERATED_BECAUSE_THE_STATUS_IS_NOT_FREE_AND_MEETS_ALL_REQUIREMENTS: "За издаване на сертификата и използване на материалите е необходимо статусът да бъде \"Освободен\" и да отговаря на всички изисквания",
  STATUS_FIELD_IS_REQUIRED: "Полето статус е задължително",
  THE_FIELD: "Полето",
  IS_REQUIRED: "е задължително",
  FREE: "Освободен",
  RELEASED: "Освободен",
  BLOCKED: "Блокиран",
  THE_FIELD_IS_REQUIRED: "Полето е задължително",
  EIK: "ЕИК",
  MOL: "МОЛ",
  MATERIALLY_RESPONSIBLE_PERSON: "Материално отговорно лице",
  NUMBER_BY_VAT: "Номер по ДДС",
  BANK: "Банка",
  CONTACT: "Контакт",
  COUNTRY: "Държава",
  CITY: "Град",
  ADDRESS: "Адрес",
  ADD_NEW_USER: "Добави нов потребител",
  SAVE: "Запази",
  WELCOME_TO_THE_SYSTEM: "Добре дошли в системата на Besta Pharmaceuticals!",
  COUNTS: "Бройки",
  REMAINING: "Оставащи",
  MADE: "направени",
  INTERNAL_BATCH_NUMBER: "Вътрешно партиден номер",
  REASONS_FOR_DESTROYING: "Причини за унищожаването",
  PROTOCOL_FOR_DESTROYING_SECONDARY_PACKAGING_MATERIALS: "Протокол за унищожаване на вторични опаковъчни материали",
  COUNT_ABBREVIATION: "бр.",
  EMAIL: "Имейл",
  THE_FIELD_MUST_BE_AT_LEAST: "Полето трябва да бъде минимум",
  THE_FIELD_MUST_BE_AT_MOST: "Полето трябва да бъде максимум",
  CHARACTERS: "знака",
  USERS: "Потребители",
  SEND_EMAIL_TO_QUALITY_CONTROL_WHEN_OPERATOR_CHECKS_IN_PAUSED_RM: "Изпрати мейл до контрол на качеството при чекиране на оператор в паузирана МК",
  PASSWORD: "Парола",
  CONFIRM_PASSWORD: "Потвърди паролата",
  NO_ACTIVE_ROUTE_MAP_IN_THIS_HALL: "Няма активна маршрутна карта в тази зала",
  SUCCESSFUL_OPERATION: "Успешна операция",
  WRONG_OPERATOR_CODE: "Грешен код на оператор",
  CONTROL_CODE: "Код за контрол",
  ADD_OPERATOR: "Добави оператор",
  BATCH_NUMBER: "Партиден №",
  RAW_PRODUCT_SCRAP: "Брак на суровина",
  START: "Старт",
  HALL_IS_MARKED_FOR_CLEANING: "Залата е отбелязана за почистване",
  HALL_IS_NOT_LOADED_WITH_RAW_PRODUCTS_AND_MATERIALS: "Залата не е заредена със суровини и материали. Зареждането е планувано за",
  HALL_IS_MARKED_FOR_RELOADING: "Залата е отбелязана за повторно зареждане",
  PLEASE_PERFORM_QUALITY_CONTROL: "Моля извършете контрол на качеството!",
  CONTROL: "Контрол",
  HOUR_ABBR: "ч.",
  MINUTE_ABBR: "мин.",
  SECOND_ABBR: "сек.",
  YEAR_ABBR: "г.",
  CANCEL: "Отказ",
  OPERATOR_CODE: "Код на оператор",
  OPERATOR_SIGNATURE_CODE: "Код за подпис на оператор",
  FINISH_WORK_ON: "Приключи работа по",
  OPERATOR: "Оператор",
  OPERATION: "Операция",
  CHOOSE: "Избери",
  ADD_NEW_OPERATION: "Добави нова операция",
  FINISH_WORK: "Приключи работа",
  BACK: "Назад",
  LEAVE_THIS_ROUTE_MAP: "Напусни тази маршрутна карта",
  THE_QUANTITY_OF_SCRAP_MATERIALS_MUST_BE_AT_LEAST: "Броят на бракувани материали трябва да бъде минимум",
  PLEASE_FILL_IN_ALL_FIELDS_CORRECTLY: "Моля попълнете всички полета коректно",
  PERFORMED_OPERATIONS: "Извършени операции",
  CORRECTED: "коригирана",
  INVOICE: "Фактура",
  NUMBER: "Номер",
  GENERATE_INVOICE: "Генерирай фактура",
  PRODUCT: "Продукт",
  PRODUCT_TYPE: "Тип продукт",
  ROUTE_MAP_NUMBER: "Номер на маршрутна карта",
  PRICE_PER_UNIT_WITHOUT_VAT: "Цена за една бройка без ДДС",
  START_DATE: "Начална дата",
  END_DATE: "Крайна дата",
  SEND: "Изпрати",
  NO_RESULTS_FOUND_FOR_THIS_PERIOD: "Няма намерени резултати за този период",
  ADD_NEW_INVOICE: "ДОБАВИ НОВА ФАКТУРА",
  DOWNLOAD_INVOICE: "Изтегли фактура",
  HALL_IS_MARKED_FOR_CORRECTION_BECAUSE_OF_THE_FOLLOWING_REASONS: "Залата е отбелязана за корекциия поради следните причини",
  EXTERNAL_APPEARANCE_COLOR_AND_COMPLETENESS_OF_THE_PACKAGING: "Външен вид, цвят, цялост на опаковката",
  PRODUCT_COMPLIANCE_WITH_THE_INSTRUCTIONS_FOR_REPACKAGING: "Съответствие на продукта с инструкциите за преопаковане",
  CLARITY_AND_VERACITY_OF_THE_BATCH_NUMBER_AND_EXPIRATION_DATE: "Четливост и достоверност на партиден номер и срок на годност",
  REMARKS: "Забележки",
  CONFIRM_THAT_THE_HALL_IS_LOADED: "Потвърдете, че залата е заредена",
  CONFIRM_THAT_THE_HALL_IS_CORRECTED: "Потвърдете, че сте извършили корекциите",
  NO_ROUTEMAPS_FOR_LOADING: "В момента няма маршрутни карти за зареждане",
  NO_CHANGES_MADE: "Не са правени промени",
  ADD_NEW_VALUE: "Добави нова стойност",
  VALUE: "Стойност",
  VALUES: "Стойности",
  SEARCH_BY_COLUMN: "Търси по колона",
  NUMBER_OF_PRIMARY_UNITS: "Брой първични единици",
  NUMBER_OF_PACKAGES: "Брой опаковки",
  SENT_EMAIL: "Изпратен имейл",
  CREATE_ACCEPTANCE_ACT: "Създай ППП",
  SEND_EMAIL: "Изпрати имейл",
  DOWNLOAD_ACCEPTANCE_ACT: "Свали ППП",
  DOWNLOAD_REQUEST_BLANK: "Изтегли бланка ЗАЯВКА",
  CREATE_ACCEPTANCE_ACT_FROM_THIS_REQUEST: "Създай Приемно-предавателен протокол от тази заявка",
  SENDING_EMAIL: "Изпращане на имейл",
  MESSAGE: "Съобщение",
  APPLY_FOR_REQUEST_NUMBER: "Здравейте, прилагаме заявка номер",
  CHOOSE_EMAILS: "Избери имейли",
  REQUIREMENTS_TO_MATERIALS: "Изисквания към материалите",
  TYPE_OF_REQUIREMENT: "Вид на изискване",
  REQUIREMENT: "Изискване",
  MATERIAL_TYPE: "Вид на материала",
  REMARK: "Забележка",
  OPERATOR_LOGIN: "Вход за оператори",
  CODE: "Код",
  REMAINING_COUNTS: "Оставащи бройки",
  BEGIN: "Започни",
  LAST_NAME: "Фамилия",
  ACTIVE: "Активен",
  INACTIVE: "Неактивен",
  SIGNATURE_CODE: "Код за подпис",
  HOLIDAYS: "Почивни дни",
  RECIPES: "Рецепти",
  INSTRUCTION_NUMBER: "Инструкция номер",
  ADD_MATERIAL: "Добави материал",
  NORM: "Норматив",
  COUNT_OF_BOXES_IN_BOX: "Брой кутии в кашон",
  PRIMARY_PACKAGES_IN_BOX: "Първични опаковки в кутия",
  COUNT_OF_MEDICINAL_UNITS_IN_PRIMARY_PACKAGE: "Брой лекарствени единици в първична опаковка",
  SELLING_PRICE_UP_TO_5000_PIECES: "Продажна цена до 5000 бройки",
  SELLING_PRICE_OVER_5000_PIECES: "Продажна цена над 5000 бройки",
  ADD_NEW_PRODUCT: "Добави нов продукт",
  STRENGTH: "Концентрация",
  MEDICINAL_FORM: "Лекарствена форма",
  CHOOSE_VENDORS: "Избери производители",
  CHOOSE_MANUFACTURE_TYPES: "Избери тип изделие",
  AUTHORIZATION_HOLDER: "Притежател на разрешение за употреба",
  REGISTER_OF_CERTIFICATE_OF_RELEASE_FOR_THE_SALE_OF_FINAL_PRODUCT: "Регистър на \"Сертификат Освобождаване за продажба на краен продукт\"",
  DOWNLOAD_EXPORT: "Свали експорт",
  GENERATE_PROTOCOL: "Генерирай протокол",
  GENERATING_OF_PROTOCOL: "Генериране на протокол",
  FARMACEUTICAL_FORM: "Фармацевтична форма",
  HOLDER_OF_PARALLEL_IMPORT_PERMISSION: "Притежател на разрешение за паралелен внос",
  BATCH_SIZE: "Големина на партидата",
  PURCHASER_FOR_REPACKAGING: "Възложител за преопаковане",
  EXPIRATION_DATE_OF_STORAGE_OF_MUSEUM_DISPLAY: "Дата на изтичане срока за съхранение на музейната мостра",
  INSUFFICIENT_QUANTITY_OF_RAW_PRODUCT: "Недостатъчно количество на суровина",
  LOADING_DATE_AND_TIME: "Дата и час на зареждане",
  MATERIAL_CONSUMPTION_NORM: "Материално разходен норматив",
  IN_THE_WAREHOUSE_FOR_MUSEUM_DISPLAYS_ALREADY_HAS_A_SAMPLE_FOR_THIS_BATCH: "В склада за музейни мостри вече съществува мостра за този партиден номер.",
  IN_THE_WAREHOUSE_FOR_BOM_DISPLAYS_ALREADY_HAS_A_SAMPLE: "В склада за мостри на BOM вече съществува мостра.",
  STICKER: "Стикер",
  INFORMATION_ABOUT_ROUTE_MAP: "Информация за маршрутната карта",
  CURRENT_CONTROL_DURING_REPACKAGING_AND_LABELING: "Текущ контрол по време на преопаковане и етикиране",
  EXTERNAL_VIEW_COLOR: "Външен вид, цвят",
  OVERALL_PACKAGING: "цялост на опаковката",
  TIME: "Час",
  PRODUCT_CONFORMITY_WITH: "Съответствие на продукта с",
  INSTRUCTIONS_FOR_REPACKAGING: "инструкциите за преопаковане",
  LEGIBILITY_AND_ACCURACY_OF_THE_BATCH_NUMBER_AND_EXPIRY_DATE_INSCRIPTIONS: "Четливост и достоверност на надписите партиден № и срок на годност",
  COMPLETED_CONTROL: "Извършен контрол",
  DATE_AND_TIME: "Дата и час",
  SAVE_CONTROL: "Запиши контрол",
  MEDICINAL_PRODUCT: "Лекарствен продукт",
  READY: "Готови",
  DESCRIPTION_OF_OUTPUT_RAW_MATERIALS_AND_PACKAGING_MATERIALS: "Описание на изходни суровини / опаковъчни материали",
  PARTICIPANTS_IN_SECONDARY_REPACKAGING: "Участници във вторично преопаковане",
  SCRAP: "Брак",
  SAVE_OPERATION: "Запиши операция",
  STATUSES: "Статуси",
  DOWNLOAD_FULL_DOCUMENT: "Изтегли пълния документ",
  FILES: "Файлове",
  REGENERATE_DOCUMENT: "Регенерирай документ",
  EDIT_AUTHORIZATION_HOLDER: "Редактирай притежател на разрешение за употреба",
  EDIT_BLOCKING_INFORMATION: "Редактирай информацията за блокиране",
  BLOCK: "Блокирай",
  BLOCK_ROUTE_MAP: "Блокиране на маршрутна карта",
  UPLOAD_FILE: "Качи файл",
  DOCUMENT_TITLE: "Заглавие на документа",
  UPLOAD: "Качи",
  ALL: "Всички",
  REASON: "Причина",
  PRINTOUT: "Разпечатка",
  EDIT_HALLS: "Редактирай залите",
  QUALITY_CONTROL_AFTER: "Контрол на качеството след",
  ARCHIVE_ROUTE_MAP_CONFIRMATION: "Сигурни ли сте, че искате да архивирате тази маршрутна карта? Tова дейтсвие не може да бъде отменено!",
  NOTE: "Бележка",
  THE_FIELD_NOTE_IS_REQUIRED: "Полето бележка е задължително",
  ARCHIVE_CONFIRMATION: "Сигурен ли си, че искаш да архивираш",
  ARCHIVE_CONFIRMATION_DESCRIPTION: "Tова дейтсвие не може да бъде отменено!",
  FINISH_ROUTE_MAP_CONFIRMATION: "Сигурни ли сте, че искате да приключите маршрутната карта?",
  NOT_ALL_COUNTS_ARE_COMPLETED: "Не са изпълнени всички бройки. Остават",
  CONFIRM: "Потвърди",
  NUMBER_OF_SCRAP_MATERIALS: "Брой на бракувани материали",
  PLEASE_CHOOSE_MATERIAL: "Моля изберете материал",
  THE_NUMBER_OF_SCRAP_MATERIALS_MUST_BE_AT_LEAST_1: "Броя на бракувани материали трябва да бъде минимум 1",
  PLEASE_CHOOSE_OPERATION: "Моля изберете операция",
  THE_NUMBER_OF_PERFORMED_OPERATIONS_MUST_BE_AT_LEAST_1: "Броя на извършените операции трябва да бъде минимум 1",
  CHECKING_OPERATOR: "Чекиране на оператор",
  PLEASE_CHOOSE_OPERATOR: "Моля изберете оператор",
  FINISH_WORK_ON: "Приключи работа по",
  FINISH: "Приключи",
  COMMENT: "Коментар",
  MARK_HERE_IF_NEEDED_FOR_CLEANING: "Отбележете тук, ако има нужда от почистване!",
  PAUSE: "Пауза",
  THE_FIELD_COMMENT_IS_REQUIRED: "Полето коментар е задължително",
  PERFORM_QUALITY_CONTROL: "Извърши контрол на качеството",
  SEND_TO_LABOURER: "Изпрати на общ работник",
  PERFORM_CONTROL: "Извърши контрол",
  NUMBER_OF_SCRAP_RAW_PRODUCTS: "Брой на бракувани суровини",
  THE_NUMBER_OF_SCRAP_RAW_PRODUCTS_MUST_BE_AT_LEAST_1: "Броя на бракувани суровини трябва да бъде минимум 1",
  MINUTES_OF_PAUSE_FROM: "Минути почивка от",
  TO: "до",
  REMAINING_TIME: "Оставащо време",
  PLEASE_CONFIRM_THAT_THE_CLEANING_HAS_BEEN_PERFORMED: "За да продължите работа, моля потвърдете, че почистването е извършено!",
  THE_LAST_WORKING_DAY_HAS_REMAINED: "От последния работен ден са останали",
  MINUTES_TO_QUALITY_CONTROL: "минути до контрол на качество.",
  PLEASE_CHECK_IN_AS_AN_OPERATOR_TO_START_THE_WORK_PROCESS: "Моля, чекирайте се като оператор, за да стартирате процеса на работа!",
  HALL_IS_MARKED_FOR_RELOADING_BECAUSE_OF_THE_FOLLOWING_REASONS: "Залата е отбелязана за повторно зареждане поради следните причини",
  EXTERNAL_VIEW_COLOR_AND_OVERALL_PACKAGING: "Външен вид, цвят и цялост на опаковката.",
  CHECKED_OPERATORS: "Чекирани оператори",
  FINISH_WORK_ON_THIS_ROUTE_MAP: "Приключи работа по тази маршрутна карта",
  COMMENTS: "Коментари",
  ADD_COMMENT: "Добави коментар",
  MATERIAL_SCRAP: "Брак на материали",
  CHECK_OPERATOR: "Чекирай оператор",
  FINISH_ROUTE_MAP: "Приключи маршрутна карта",
  QUALITY_CONTROL: "Контрол на качеството",
  FIRST_CONTROL_OF_THE_DAY: "Първи контрол за деня",
  LAST_CONTROL_PERFORMED: "Последно извършен контрол",
  PERFORMED_CONTROLS_TODAY: "Извършени контроли днес",
  NEXT_PAUSE: "Следваща почивка",
  MINUTES_FROM: "минути от",
  THERE_IS_NO: "Няма",
  PERFORMED_PAUSES_TODAY: "Извършени паузи днес",
  PERFORMED_CHARGING: "Извършил зареждане",
  ON: "на",
  USER: "Потребител",
  CORRECTION: "Корекция",
  PERFORMED_QUALITY_CONTROL: "Извършен контрол на качеството",
  CLARITY_AND_VERACITY_OF: "Четливост и достоверност на",
  BATCH_NUMBER_AND_EXPIRATION_DATE: "партиден номер и срок на годност",
  QUANTITY_FOR_PRODUCTION: "Бройки за производство",
  READY_QUANTITY: "Готови бройки",
  REMAINING_QUANTITY: "Оставащи бройки",
  INSERTED_QUANTITY: "Вложени бр.",
  SAMPLE: "Мостра",
  RETURNED: "Върнати",
  BEGINNING: "Начало",
  END: "Край",
  PRODUCER_BATCH_NUMBER: "Партиден номер на производител",
  ROLE: "Роля",
  APP_TITLE: "Besta Pharmaceuticals",
  PLEASE_RELOAD_THE_PAGE_AND_TRY_AGAIN: "Моля презаредете страницата и опитайте отново",
  TABLE: "Таблица",
  PER_PAGE: "Резултати на страница",
  RESULTS: "резултата",
  SEARCH: "Търсене",
  NO_DATA: "Няма данни",
  NEW: "Нов",
  NEWO: "Ново",
  NEWA: "Новa",
  ADD_REQUIREMENT: "Добави ново изискване",
  ADD_RECIPE: "Добави нова рецепта",
  ADD_HALL: "Добави нова зала",
  ADD_EMAIL: "Добави нов имейл",
  ADD_DESTRUCTION_PROTOCOL: "Добави нов протокол за унищожаване",
  READY: "Готово",
  EXPORT: "Експорт",
  FROM: "от",
  WORK_BREAK: "Почивка",
  VENDOR: "Производител",
  WAREHOUSE: "Склад",
  MATERIAL_REQUIREMENT: "Изискване за материали",
  ENTER_VALID_EMAIL: "Въведете валиден имейл.",
  PASSWORDS_DO_NOT_MATCH: "Паролите не съвпадат.",
  PASSWORD_IS_REQUIRED: "Паролата е задължителна.",
  TO_PROCEED_ENTER_EMAIL_CODE: "За да продължите, въведете 6 цифрения код изпратен на вашия имейл!",
  ENTER_VALID_CODE: "Въведете валиден код.",
  FORGOT_PASSWORD: "Забравена парола?",
  PASSWORD_RESET_LINK_SENT: "Ще получите имейл с линк за рестартиране на паролата си.",
  ENTER_YOUR_EMAIL_TO_RESET_PASSWORD: "Въведете вашия имейл, за да рестартирате паролата си!",
  ENTER_YOUR_NEW_PASSWORD: "Въведете вашата нова парола",
  CONFIRM_PASSWORD: "Потвърдете парола",
  HOLIDAYS_FOR_OPERATORS: "Почивни дни за оператори",
  ADD_HOLIDAY: "Добави почивен ден",
  EDIT_HOLIDAY: "Редактирай почивен ден",
  END_DATE_MUST_BE_GREATER_THAN_START_DATE: "Крайната дата трябва да бъде по-голяма от началната дата",
  ADD_NEW_FORM_TYPE: "Добави нова лекарствена форма",
  FORM_TYPE_ADDED_SUCCESSFULLY: "Лекарствената форма беше добавена успешно",

  LABELS: {
    acceptanceActDetail: {
      expirationDate: "Срок на годност",
      batch: "Партиден номер",
      acceptanceAct: {
        client: {
          name: "Възложител"
        }
      }
    },
    documentType: "Вид на документа",
    routeMap: {
      certificate: {
        id: "id",
        signedAt: "Дата",
        number: "Номер на сертификат"
      },
      certificateNumber: {
        number: "Номер на сертификат"
      },
      id: "id",
      finishDate: "Дата на създаване",
      product: {
        name: "Име и концентрация"
      }
    },
    materialName: "Материал",
    login: {
      email: "Имейл"
    },
    client: {
      name: "Клиент"
    },
    LOG_BTN: "Лог",
    sealCode: "Код на мениджър",
    createdAt: "Създаден на",
    address: "Адрес",
    id: "ID",
    name: "Име",
    email: "Email",
    values: "Стойности",
    role: "Роля",
    strength: "Концентрация",
    "raw-product": {
      name: "Име",
      strength: "Концентрация",
      ma_holder: "Притежател на разрешение за употреба",
      primary_q_i_b: "Първични опаковки в кутия",
      vendor: {
        name: "Име"
      },
      formType: {
        name: "Лекарствена форма"
      },
      manufactureType: {
        name: "Тип изделие"
      },
      note: "Бележка"
    },
    "destruction-packaging-material": {
      signed_by_qualified: "Подписан",
      client: {
        name: "Възложител"
      },
      quantity: "Количество",
      material: {
        name: "Материал",
        type: {
          name: "Тип"
        }
      },
      reason: "Причина"
    },
    "prepared-product": {
      name: "Име",
      primary_q_i_b: "Първични опаковки в кутия",
      note: "Забележка",
      quantity_in_medical_package:
        "Брой лекарствени единици в първична опаковка",
      price_under: "Продажна цена до 5000 бройки",
      price_over: "Продажна цена над 5000 бройки",
      q_i_b: "Брой кутии в кашон",
      quantity: "Количество",
      norm: "Норматив",
      typeable: {
        name: "Суровина"
      },
      product: {
        name: "Име на продука"
      },
      formula: {
        name: "Име"
      },
      client: {
        name: "Клиент"
      }
    },
    qIB: "Кутии в кашон",
    primaryQIB: "Първични опаковки в кутия",
    primaryQuantity: "Първични опаковки",
    priceUnder: "Продажна цена до 5000 бройки",
    priceOver: "Продажна цена над 5000 бройки",
    primary_qIB: "Първични опаковки в кутия",
    primary_quantity: "Първични опаковки",
    price_under: "Продажна цена до 5000 бройки",
    price_over: "Продажна цена над 5000 бройки",
    mol: "Мол",
    eik: "ЕИК",
    firstName: "Име",
    lastName: "Фамилия",
    active: "Активен",
    number: "Код",
    date: "Дата",
    status_id: "status_id",
    start_date: "Начална дата",
    finish_date: "Дата на приключване",
    startDate: "Начална дата",
    finishDate: "Дата на приключване",
    endDate: "Крайна дата",
    quantity: "Брой",
    halls: "Зала",
    batch: "Партида",
    product_raw_quantity: "Бройка суровина",
    product_quantity: "Бройка",
    instruction_id: "Инструкция",
    user_id: "потр. ID",
    product_formula_id: "формула id",
    materialDate: "Дата на зареждане",
    material_date: "Дата на зареждане",
    remainQuantity: "Останали бройки",
    readyQuantity: "Готови бройки",
    remain_quantity: "Останали бройки",
    ready_quantity: "Готови бройки",
    operator: "Оператор",
    completedNorm: "Изпълнена норма",
    year: "Година",
    month: "Месец",
    monthAverage: "Средно месечно",
    norm: "Норма",
    made: "Изработено",
    result: "Резултат",
    from: "От",
    to: "До",
    startTime: "Начало",
    endTime: "Край",
    holidaysFor: "Почивни дни за",
    operations: "Операции",
    productManager: {
      name: "Мениджър"
    },
    status: {
      name: "Статус"
    },
    type: {
      name: "Вид"
    },
    product: {
      name: "Продукт"
    },

    material: {
      name: "Материал",
      note: "Бележка",
      type: {
        name: "Вид"
      },
      client: {
        name: "Клиент"
      },
      product: {
        name: "Име"
      },
      property: {
        name: "Изискване"
      }
    },
    invoice: {
      user: {
        name: "Потребител"
      },
      quantity: "Количество",
      price: "Цена",
      paymentType: {
        name: "Начин на плащане"
      },
      number: "Номер",
      status: {
        name: "Статус"
      },
      date: "Дата"
    },
    nextControl: "Следващ контрол",
    next_control: "Следващ контрол",
    "material-details-property": {
      name: "Име",
      property: {
        name: "Име"
      }
    },
    warehouse: {
      name: "Име"
    },
    vendor: {
      name: "Име",
      address: "Адрес"
    },
    printery: {
      name: "Име",
      address: "Адрес"
    },
    clients: {
      name: "Име",
      eik: "ЕИК",
      mol: "Мол",
      vat: "Номер по ДДС",
      bank: "Банка",
      iban: "IBAN",
      contact: "Контакт",
      country: "Държава",
      city: "Град",
      address: "Адрес"
    },
    "material-request": {
      client: {
        name: "Клиент"
      },
      country: "Държава",
      date: "Дата",
      fromWarehouse: {
        name: "От склад"
      },
      toWarehouse: {
        name: "Към склад"
      },
      rawProduct: {
        name: "Суровина"
      },
      batch: "Партида",
      buy: "Срок на годност",
      quantity: "Количество",
      number: "Номер"
    },
    operators: {
      first_name: "Име",
      last_name: "Фамилия",
      seal_code: "Код за подписване",
      code: "Код",
      active: "Активен"
    },
    certificate: {
      signed_by_qualified: "Подписан",
      certificateType: {
        name: "Тип"
      },
      material: {
        name: "Материал"
      },
      batch: "Партиден номер",
      vendor: {
        name: "Печатница"
      },
      vendor_batch: "Партиден номер на производител",
      quantity: "Количество",
      user: {
        name: "Потребител"
      },
      note: "Коментар",
      status: {
        name: "Статус"
      },
      delivery_date: "Дата на доставка",
      date: "Дата",
      conclusion: "Заключение",
      answer: "Отговаря",
      property: {
        name: "Показател"
      },
      value: "Изисквания",
      number: "Код",
      client: {
        name: "Клиент"
      }
    },
    user: {
      name: "Име",
      email: "Имейл",
      seal_code: "Код за подпис"
    },
    "route-map": {
      description: "Описание",
      user: {
        name: "Потребител"
      },
      comment_before_pause: "Коментар преди паузата",
      comment_after_start: "Коментар след паузата",
      scrap: "Брак бр.",
      returned: "Върнати бр.",
      package: "Външен вид, цвят и цялост на опаковката",
      instructions: "Съответствие на продукта с инструкциите за преопаковане",
      batch: "Четливост и достоверност на партиден № и срок на годност",
      notes: "Бележки",
      nextControl: "Следващ контрол",
      next_control: "Следващ контрол",
      name: "изходни суровини / опаковъчни материали",
      status: {
        name: "Статус"
      },
      operator: {
        name: "Име"
      },
      start_date: "Начална дата",
      finish_date: "Приключена на",
      product: {
        name: "Продукти"
      },
      quantity: "Количество",
      productManager: {
        name: "Мениджър"
      },
      product_raw_quantity: "Количество суровини",
      product_quantity: "Количество суровини",
      material_date: "Дата и час на зареждане"
    }
  },
  LABEL_LOGS: {
    emails: {
      email: "Имейл"
    },
    login: {
      email: "Имейл"
    },
    client: {
      name: "Клиент"
    },
    strength: "Концентрация",
    "raw-product": {
      name: "Име",
      strength: "Концентрация",
      ma_holder: "Притежател на разрешение за употреба",
      primary_q_i_b: "Първични опаковки в кутия",
      vendor: {
        name: "Име"
      },
      formType: {
        name: "Лекарствена форма"
      },
      manufactureType: {
        name: "Тип изделие"
      },
      note: "Бележка"
    },
    "work-breaks": {
      start_time: "Начало",
      end_time: "Край"
    },
    "destruction-packaging-material": {
      signed_by_qualified: "Подписан",
      certificate: {
        number: "Код"
      },
      client: {
        name: "Възложител"
      },
      quantity: "Количество",
      material: {
        name: "Материал",
        type: {
          name: "Тип"
        }
      },
      reason: "Причина"
    },
    "prepared-product": {
      name: "Име",
      primary_q_i_b: "Първични опаковки в кутия",
      note: "Забележка",
      quantity_in_medical_package:
        "Брой лекарствени единици в първична опаковка",
      price_under: "Продажна цена до 5000 бройки",
      price_over: "Продажна цена над 5000 бройки",
      q_i_b: "Брой кутии в кашон",
      quantity: "Количество",
      norm: "Норматив",
      typeable: {
        name: "Суровина"
      },
      product: {
        name: "Име на продука"
      },
      formula: {
        name: "Име"
      },
      client: {
        name: "Клиент"
      }
    },
    productManager: {
      name: "Мениджър"
    },
    status: {
      name: "Статус"
    },
    type: {
      name: "Вид"
    },
    product: {
      name: "Продукт"
    },
    material: {
      name: "Материал",
      note: "Бележка",
      type: {
        name: "Вид"
      },
      client: {
        name: "Клиент"
      },
      product: {
        name: "Име"
      },
      property: {
        name: "Изискване"
      },
      manufactureType: {
        name: "Тип изделие"
      },
    },
    invoice: {
      user: {
        name: "Потребител"
      },
      quantity: "Количество",
      price: "Цена",
      paymentType: {
        name: "Начин на плащане"
      },
      number: "Номер",
      status: {
        name: "Статус"
      },
      manufactureType: {
        name: "Тип изделие"
      },
      date: "Дата"
    },
    "material-details-property": {
      name: "Име",
      property: {
        name: "Име"
      }
    },
    warehouse: {
      name: "Име"
    },
    vendor: {
      name: "Име",
      address: "Адрес"
    },
    printery: {
      name: "Име",
      address: "Адрес",
    },
    clients: {
      name: "Име",
      eik: "ЕИК",
      mol: "Мол",
      vat: "Номер по ДДС",
      bank: "Банка",
      iban: "IBAN",
      contact: "Контакт",
      country: "Държава",
      city: "Град",
      address: "Адрес",
    },
    "material-request": {
      client: {
        name: "Клиент"
      },
      country: "Държава",
      date: "Дата",
      fromWarehouse: {
        name: "От склад"
      },
      toWarehouse: {
        name: "Към склад"
      },
      rawProduct: {
        name: "Суровина"
      },
      batch: "Партида",
      buy: "Срок на годност",
      quantity: "Количество",
      number: "Номер",
      status: "Статус",
      number_primary_units: "Брой първични единици",
      packages: "Брой опаковки"
    },
    operators: {
      first_name: "Име",
      last_name: "Фамилия",
      seal_code: "Код за подписване",
      code: "Код",
      active: "Активен"
    },
    certificate: {
      conclusion_protocol: "Заключение (Протокол)",
      signed_by_qualified: "Подписан",
      certificateType: {
        name: "Тип"
      },
      material: {
        name: "Материал"
      },
      batch: "Партиден номер",
      vendor: {
        name: "Печатница"
      },
      vendor_batch: "Партиден номер на производител",
      quantity: "Количество",
      user: {
        name: "Потребител"
      },
      note: "Коментар",
      status: {
        name: "Статус"
      },
      delivery_date: "Дата на доставка",
      date: "Дата",
      conclusion: "Заключение (Сертификат)",
      answer: "Отговаря",
      property: {
        name: "Показател"
      },
      value: "Изисквания",
      number: "Код",
      client: {
        name: "Клиент"
      }
    },
    user: {
      name: "Име",
      email: "Имейл",
      seal_code: "Код за подпис",
      role: {
        name: "Роля"
      }
    },
    "route-map": {
      vendor: {
        name: "Производител"
      },
      reason: "Причина",
      comment: "Коментар",
      authorization_holder: "Притежател на разрешение за употреба",
      product_batch: "Партида",
      archive_note: "Бележка",
      sample: "Мостра",
      warehouse_has_sample:
        "В склада за музейни мостри вече съществува мостра за този партиден номер.",
      description: "Описание",
      date: "Дата",
      signed: "Подписана",
      signed_at: "Подписана на",
      is_sent_to_labourer: "Изпратена на общ работник",
      user: {
        name: "Потребител"
      },
      finishedBy: {
        name: "Приключил маршрутната карта"
      },
      operation: {
        name: "Име на операция"
      },
      comment_before_pause: "Коментар преди паузата",
      comment_after_start: "Коментар след паузата",
      scrap: "Брак бр.",
      returned: "Върнати бр.",
      package: "Външен вид, цвятцялост на опаковката",
      instructions: "Съответствие на продукта с инструкциите за преопаковане",
      batch: "Четливост и достоверност на партиден № и срок на годност",
      notes: "Бележки",
      nextControl: "Следващ контрол",
      next_control: "Следващ контрол",
      name: "изходни суровини / опаковъчни материали",
      status: {
        name: "Статус"
      },
      operator: {
        name: "Име",
        first_name: "Оператор име",
        last_name: "Оператор фамилия"
      },
      start_date: "Начална дата",
      finish_date: "Приключена на",
      product: {
        name: "Продукти"
      },
      quantity: "Количество",
      productManager: {
        name: "Мениджър"
      },
      product_raw_quantity: "Количество суровини",
      product_quantity: "Количество суровини",
      material_date: "Дата и час на зареждане"
    },
    halls: {
      name: "Име",
      login: {
        email: "Имейл"
      }
    },
    1: "Да",
    0: "Не",
    true: "Да",
    false: "Не"
  },
  LOGS: {
    break_finished: "Край на почивката",
    break_added: "Начало на почивка",
    updated: "Редактиран/а",
    break_interrupted: "Почивката е прекъсната",
    product_scrap_added: "Брак на суровини",
    material_scrap_added: "Брак на материали",
    operator_logout: "Оператор приключи работа",
    operator_login: "Оператор се чекира",
    operation_create: "Извършена операция",
    cost_standard_updated: "Обновен разходен норматив",
    control_successful: "Успешен контрол",
    charged: "Залата е заредена",
    cleaned: "Залата е почистена",
    created: "Създаден/а",
    route_map_operation_created: "Извършена операция",
    created_user_role: "Потребителят е свързан към нова роля",
    deleted_user_role: "Потребителят е премахнат от роля",
    route_map_operation_deleted: "Операцията беше изтрита",
    control_failed: "Неуспешен контрол",
    product_formula_was_created: "Добавена е нова рецепта",
    product_formula_material_was_deleted: "Инструкцията беше изтрита",
    product_operation_was_created: "Добавена е нова операция",
    product_operation_was_deleted: "Операцията беше изтрита",
    product_manufacturer_was_created: "Добавен е производител",
    route_map_blocking: "Маршрутната карта е блокирана",
    product_manufacturer_was_deleted: "Производителят е премахнат",
    material_product_map_was_created: "Добавен е продукт",
    material_detail_was_created: "Добавено е ново изискване",
    material_detail_was_deleted: "Изискването беше изтрито",
    deleted: "Изтрит",
    material_detail_property_value_was_created: "Нова стойност",
    material_detail_property_value_was_deleted: "Стойността беше изтрита",
    material_request_detail_was_created: "Добавен е нов продукт",
    material_request_detail_was_updated: "Продуктът беше редактиран",
    material_request_detail_was_deleted: "Продуктът беше изтрит",
    acceptance_act_was_created: "Създаден е ППП",
    certificate_result_was_created: "Добавен е показател",
    certificate_result_was_updated: "Променен е показател",
    destruction_protocol_product_was_created: "Продуктът беше добавен",
    destruction_protocol_product_was_updated: "Продуктът беше редактиран",
    destruction_protocol_product_was_deleted: "Продуктът беше изтрит",
    destruction_protocol_was_signed: "Протоколът беше подписан",
    invoice_detail_deleted: "Продуктът беше изтрит",
    invoice_detail_updated: "Продуктът беше променен",
    invoice_detail_created: "Добавен е продукт",
    certificate_signed_by_qualified: "Подписан",
    route_map_updated_by_admin: "Редактирана от администратор",
    route_map_updated_by_admin_printout: "Редактирана от администратор",
    route_map_updated_printout: "Редактирана",
    cost_standard_updated_by_admin:
      "Разходния норматив беше променен от администратор",
    cost_standard_updated_by_manager:
      "Разходния норматив беше променен от мениджър",
    route_map_operation_updated: "Операцията беше редактирана",
    product_formula_material_was_created:
      "Добавена е нова инструкция към рецепта",
    update_batch: "Партидата беше променена",
    product_operation_was_updated: "Операция към продукт беше редактирана",
    comment_added: "Добавен е коментар",
    pause_added: "Добавена е пауза",
    pause_finished: "Пауза приключена",
  },
  MONTHS: {
    1: "Януари",
    2: "Февруари",
    3: "Март",
    4: "Април",
    5: "Май",
    6: "Юни",
    7: "Юли",
    8: "Август",
    9: "Септември",
    10: "Октомври",
    11: "Ноември",
    12: "Декември"
  }
};
